import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
import { Router } from '@angular/router';
import { DataService } from '../../_services';
import * as _moment from 'moment';
import { NgxCsvParser, NgxCSVParserError } from 'ngx-csv-parser';

@Component({
  selector: 'app-data-patch',
  templateUrl: './data-patch.component.html',
  styleUrls: ['./data-patch.component.css']
})
export class DataPatchComponent implements OnInit {
  @ViewChild('file', {read:null, static:false}) file: ElementRef;
  
  uploadCSVData: string;
  tblArr: string[] = [];
  arrFirstLine: string[] = [];
  arrSecondLine: string[] = [];
  date: any;
  startHour: number;
  endHour: number;
  fileUpload: boolean = false;
  // arrColNames: string[] = [];
  arrRowNames: string[] = [];
  arrTblBody: string[] = [];

  csvRecords: any[] = [];
  header = false;
  showFileUpload: boolean = true;

  constructor(
    private router: Router,
    private changeDetector : ChangeDetectorRef,
    public svcData: DataService,
    private ngxCsvParser: NgxCsvParser
  ) { }

  ngOnInit() {
  }

  @ViewChild('fileImportInput', { static: false }) fileImportInput: any;
 
  fileChangeListener($event: any): void {
 
    const files = $event;
    this.prepareFileUploadData($event);
 
    this.ngxCsvParser.parse(files[0], { header: this.header, delimiter: ',' })
      .pipe().subscribe((result: Array<any>) => {
 
        if(result){
          this.arrFirstLine = result[0];
          var arrRes = result;
          this.csvRecords = arrRes.splice(1);          
          this.fileUpload = true;
        }
      }, (error: NgxCSVParserError) => {
        console.log('Error', error);
      });
 
  }

  // onFileChange(files: any){
  //   if (files && files.length > 0) {
  //     let _file: File = files.item(0);
  //     let fileReader: FileReader = new FileReader();
  //     fileReader.readAsText(_file);
  //     fileReader.onload = ev => {
  //       let csvdata = fileReader.result.toString();
  //       //csvdata = csvdata.toString().replace('hr','').toString();
  //       this.uploadCSVData = csvdata;
  //       this.tblArr = csvdata.split(',', csvdata.length-1);
  //       var strFirstLine = csvdata.split(/\r?\n/)[0];
  //       var strSecondLine = csvdata.split(/\r?\n/)[1];
  //       this.arrFirstLine = strFirstLine.split(',',strFirstLine.length-1);
  //       this.arrSecondLine = strSecondLine.split(',',strSecondLine.length-1);
  //       this.startHour = parseInt(this.arrFirstLine[1].replace('hr',''));
  //       this.endHour = parseInt(this.arrFirstLine[this.arrFirstLine.length - 2].replace('hr',''));
  //       let body = {data:csvdata};
  //       this.fileUpload = true;        
  //     };
  //   }
  // }
  
  Cancel(event: any){
    this.fileImportInput.nativeElement.value = '';
    this.fileUpload = false;
    this.showFileUpload = true;
    //window.location.reload();
  }
  CacheCancel(event: any){
    this.showFileUpload = true;
  }

  prepareFileUploadData(files: any){
    if (files && files.length > 0) {
      let _file: File = files.item(0);
      let fileReader: FileReader = new FileReader();
      fileReader.readAsText(_file);
      fileReader.onload = ev => {
        let csvdata = fileReader.result.toString();
        this.uploadCSVData = csvdata;
        this.tblArr = csvdata.split(',', csvdata.length-1);
        var strFirstLine = csvdata.split(/\r?\n/)[0];
        this.arrFirstLine = strFirstLine.split(',',strFirstLine.length-1);
        this.startHour = parseInt(this.arrFirstLine[1].replace('hr',''));
        this.endHour = parseInt(this.arrFirstLine[this.arrFirstLine.length - 2].replace('hr',''));
      };
    }
  }

  Upload(events: any){
    this.tblArr.forEach((element,i) => {
      this.tblArr[i] = element.replace('hr','');
    });
    var arrDt = this.tblArr[0].split('/',3);
    var strDate = arrDt[2].toString()+'-'+arrDt[1].toString()+'-'+arrDt[0].toString()+' 00:00:00';
    var date = _moment(new Date(strDate)).format("YYYY-MM-DD");
    this.date = date;

    this.svcData.uploadCSV(this.uploadCSVData.toString(), date, this.startHour,this.endHour,480).subscribe(res=>{      
      
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      } 
      else{
        this.showAlert('File upload successful!');
        this.fileImportInput.nativeElement.value = '';
        this.fileUpload = false;
        this.showFileUpload = false; // for cache rebuild
      }     
    });    
  }
  CacheRebuild(event: any){
    this.svcData.cacheRebuild(this.date).subscribe(res=>{ 
      this.showAlert('Cache Rebuild Successful!');
      this.showFileUpload = true;
     });
  }
  showAlert(msg){
    M.toast({html: msg});
  }
  goto = function(argRout){
    this.router.navigate([argRout]);
  }
}
